__turbopack_context__.v({
  "avatar": "CreatorBox-module-scss-module__Ma48Sa__avatar",
  "businessName": "CreatorBox-module-scss-module__Ma48Sa__businessName",
});
